import React from 'react';
import { AutoAwesome } from '@mui/icons-material';
import { useFreyaPopover } from 'src/presentations/components/organisms/askFreya/useFreyaPopover';

export const AskFreyaBanner: React.FC = () => {
  const { openPopover } = useFreyaPopover();
  return (
    <div className='relative w-full overflow-hidden rounded-8 p-24 flex items-center justify-between group cursor-pointer border bg-[#1C2429]'>
      {/* Background Gradients/Glows - Subtle enhancement */}
      <div className='absolute top-0 right-0 w-[400px] h-[400px] bg-primary opacity-[0.03] blur-[120px] rounded-full translate-x-1/2 -translate-y-1/2 pointer-events-none' />

      <div className='flex items-center gap-16 z-10 relative'>
        <div className='flex flex-col'>
          <h3 className='text-20 font-bold text-white tracking-tight'>Ask Freya</h3>
          <p className='text-14 text-neutral-40'>Learn how to get the most out of Freya The GTM Architect</p>
        </div>
      </div>

      <div className='z-10 relative'>
        <button
          type='button'
          onClick={() => openPopover('center')}
          className='flex items-center gap-8 bg-primary hover:bg-green-60 text-white font-bold py-10 px-20 rounded-8 transition-all hover:shadow-lg hover:shadow-primary/20 text-14'
        >
          Ask Freya
          <AutoAwesome sx={{ fontSize: 16 }} />
        </button>
      </div>
    </div>
  );
};
